import React from "react";

function Empty() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='862.703'
      height='644.786'
      data-name='Layer 1'
      version='1.1'
      viewBox='0 0 862.703 644.786'
      className='illustration img-fluid'
    >
      <path
        fill='#9e616a'
        d='M629.943 612.644L612.777 612.644 604.608 546.435 629.943 546.435 629.943 612.644z'
      ></path>
      <path
        fill='#2f2e41'
        d='M807.651 769.992h-12.31l-2.197-11.622-5.628 11.622h-32.649a7.34 7.34 0 01-4.17-13.378l26.072-18.007v-11.75l27.424 1.637z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#9e616a'
        d='M731.923 590.981L718.148 601.224 672.085 552.969 692.415 537.851 731.923 590.981z'
      ></path>
      <path
        fill='#2f2e41'
        d='M925.588 737.048l-9.878 7.345-8.698-8.015 2.419 12.685-26.2 19.482a7.34 7.34 0 01-11.329-8.247l10.177-30.008-7.011-9.428 22.983-15.05z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#023e8a'
        fillOpacity='1'
        d='M818.576 398.647S851.145 426.785 836.118 507l-18.346 78.597 59.83 99.256-19.077 23.207-77.78-107.433-28.185-66.114-7.908-117.669z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#023e8a'
        fillOpacity='1'
        d='M599.447 425.746L597.488 456.084 603.483 585.365 631.692 580.452 637.083 488.406 599.447 425.746z'
      ></path>
      <path
        fill='#ffb6b6'
        d='M237.445 628.211L252.796 628.21 260.098 569.001 237.443 569.002 237.445 628.211z'
      ></path>
      <path
        fill='#2f2e41'
        d='M402.178 750.806h4.32l16.87-6.86 9.04 6.859h.002a19.266 19.266 0 0119.265 19.265v.626l-49.496.002z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#ffb6b6'
        d='M296.932 618.538L311.905 621.918 332.071 565.772 309.972 560.782 296.932 618.538z'
      ></path>
      <path
        fill='#2f2e41'
        d='M462.865 740.393l4.214.952 17.966-2.976 7.308 8.682h.001a19.266 19.266 0 0114.549 23.036l-.138.61-48.281-10.9z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#0077b6'
        fillOpacity='1'
        d='M386.652 393.843c-7.197 21.706-6.437 45.268 1.73 70.556l3.49 142.378s-5.2 93.369 11.582 126.225h24.34l12.051-134.752 1.514-90.445 52.182 76.305L460.305 730.8l29.956 2.678 53.934-159.191-66.543-154.443z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#e6e6e6'
        d='M667.346 332.015c18.617-16.777 46.309-25.212 69.537-15.805a115.466 115.466 0 00-51.888 59.935c-3.698 9.838-6.786 21.166-15.882 26.433-5.66 3.278-12.7 3.438-19.045 1.856-6.346-1.583-12.163-4.754-17.9-7.894l-1.632-.037c7.328-23.966 18.193-47.712 36.81-64.488z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M736.753 316.72a98.692 98.692 0 00-54.906 25.93 42.5 42.5 0 00-8.345 10.377 24.376 24.376 0 00-2.818 12.515c.1 4.059.674 8.198-.214 12.21a14.925 14.925 0 01-7.425 9.689c-4.546 2.613-9.76 3.437-14.886 4.065-5.692.698-11.615 1.332-16.542 4.525-.597.387-1.162-.562-.566-.949 8.572-5.554 19.42-3.533 28.637-7.24 4.301-1.73 8.107-4.766 9.454-9.357 1.178-4.015.59-8.284.453-12.392a26.01 26.01 0 012.3-12.34 39.29 39.29 0 017.915-10.66 95.75 95.75 0 0124.333-17.42 100.443 100.443 0 0132.6-10.058c.703-.09.709 1.014.01 1.104z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M686.447 337.791a14.807 14.807 0 011.633-19.104c.506-.498 1.305.265.798.764a13.71 13.71 0 00-1.482 17.774c.415.577-.536 1.14-.949.566z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M670.362 363.491a28.54 28.54 0 0020.394-4.083c.598-.385 1.164.564.566.948a29.685 29.685 0 01-21.23 4.206c-.7-.126-.427-1.196.27-1.07z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M714.447 321.948a8.381 8.381 0 006.268 4.894c.702.118.427 1.188-.27 1.071a9.392 9.392 0 01-6.947-5.399.57.57 0 01.191-.757.555.555 0 01.758.19z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#e6e6e6'
        d='M762.461 397.115a79.27 79.27 0 00-1.328-.176 110.379 110.379 0 00-17.882-.908c-.462.006-.93.02-1.391.04a116.365 116.365 0 00-41.75 9.61 113.005 113.005 0 00-15.163 8.056c-6.688 4.234-13.602 9.357-21.078 11.084a19.386 19.386 0 01-2.363.421l-30.888-26.745c-.04-.096-.086-.186-.126-.282l-1.282-1.011c.239-.176.49-.353.729-.528.138-.103.283-.2.42-.302.095-.066.19-.132.27-.198.032-.022.064-.044.089-.059.081-.065.163-.117.238-.175q2.104-1.49 4.236-2.955c.006-.007.006-.007.019-.008a166.157 166.157 0 0134.6-18.6c.368-.138.74-.284 1.121-.41a107.831 107.831 0 0116.94-4.767 95.329 95.329 0 019.552-1.334 79.272 79.272 0 0124.723 1.751c16.144 3.744 30.91 12.608 39.656 26.433.224.354.44.702.658 1.063z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M762.052 397.446a98.692 98.692 0 00-59.451-12.353 42.5 42.5 0 00-12.911 3.26 24.376 24.376 0 00-9.785 8.298c-2.363 3.3-4.398 6.95-7.522 9.62a14.925 14.925 0 01-11.762 3.265c-5.202-.65-9.861-3.131-14.333-5.716-4.965-2.87-10.076-5.93-15.932-6.347-.71-.05-.59-1.149.119-1.098 10.188.726 17.633 8.87 27.224 11.46 4.476 1.208 9.343 1.075 13.182-1.78 3.358-2.495 5.46-6.258 7.823-9.62a26.01 26.01 0 019.266-8.47 39.29 39.29 0 0112.738-3.744 95.75 95.75 0 0129.916.741 100.443 100.443 0 0132.085 11.596c.616.351-.045 1.237-.657.889z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M709.199 383.983a14.807 14.807 0 0112.805-14.27c.705-.094.883.997.178 1.09a13.711 13.711 0 00-11.885 13.3c-.016.71-1.114.587-1.098-.12z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M680.883 394.82a28.54 28.54 0 0018.742 9.017c.71.053.59 1.151-.12 1.098a29.685 29.685 0 01-19.483-9.423c-.483-.523.38-1.213.86-.693z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M741.094 388.19a8.381 8.381 0 002.058 7.683c.49.516-.374 1.205-.86.692a9.392 9.392 0 01-2.296-8.493.57.57 0 01.608-.49.555.555 0 01.49.609z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#e6e6e6'
        d='M219.922 754.743c-1.45 5.44-5.26 9.97-9.86 13.27-.75.54-1.52 1.04-2.3 1.51-.24.14-.48.29-.73.42q-.405.24-.81.45h-21.63c-.39-.79-.77-1.59-1.15-2.38-9.27-19.48-15.78-40.5-14.67-61.91a79.254 79.254 0 015.17-24.25c5.94-15.47 16.78-28.86 31.69-35.6.37-.17.76-.34 1.14-.5l-.36 1.28a110.785 110.785 0 00-3.38 17.59c-.06.46-.11.92-.15 1.39a116.054 116.054 0 003.72 42.69l.03.1q1.275 4.605 2.96 9.07c.88 2.35 1.83 4.67 2.87 6.95 4.34 9.57 10.16 19.77 7.46 29.92z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M207.042 646.203c-.21.28-.42.55-.63.83a98.129 98.129 0 00-11.12 18.76c-.16.33-.31.66-.44 1a97.814 97.814 0 00-7.82 29.24 1.49 1.49 0 00-.02.21c-.25 2.36-.4 4.74-.46 7.12a42.48 42.48 0 001.43 13.24 23.769 23.769 0 005.46 9.42c.25.27.5.54.77.8.2.21.42.42.63.62 2.02 1.93 4.23 3.72 6.13 5.79a21.432 21.432 0 012.35 3 14.904 14.904 0 011.6 12.1c-1.36 5.06-4.47 9.33-7.65 13.4-1.59 2.04-3.23 4.1-4.65 6.28-.52.78-1 1.57-1.44 2.38h-1.26c.42-.81.88-1.6 1.38-2.38 3.65-5.75 8.84-10.69 11.53-17.02 1.82-4.27 2.37-9.11.07-13.3a17.682 17.682 0 00-2.43-3.38c-1.83-2.07-4.02-3.84-6.01-5.71-.5-.47-.99-.95-1.46-1.45a24.964 24.964 0 01-5.64-8.9 39.23 39.23 0 01-1.94-13.13c0-2.84.15-5.7.43-8.54.03-.36.07-.73.11-1.1a100.767 100.767 0 0119.67-49.23c.2-.28.41-.55.62-.82.43-.56 1.22.22.79.77z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M186.365 696.678a14.807 14.807 0 01-12.354-14.663.553.553 0 011.105-.024 13.711 13.711 0 0011.52 13.616c.7.114.427 1.184-.27 1.07z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M193.164 726.224a28.54 28.54 0 0011.533-17.308c.151-.695 1.222-.424 1.071.27a29.685 29.685 0 01-12.038 17.986c-.585.407-1.148-.544-.566-.948z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M194.96 665.676a8.381 8.381 0 007.894-.972c.58-.413 1.142.538.566.949a9.392 9.392 0 01-8.73 1.094.57.57 0 01-.4-.67.555.555 0 01.67-.401z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#e6e6e6'
        d='M282.062 684.873c-.35.27-.71.54-1.06.82a110.362 110.362 0 00-13.29 12c-.32.33-.64.67-.95 1.01l-.01.01a116.347 116.347 0 00-22.66 36.14l-.03.09c-.01.03-.02.05-.03.08a114.443 114.443 0 00-5.03 16.42c-1.22 5.46-2.22 11.31-4.13 16.57-.29.81-.61 1.61-.95 2.38h-44.46c.15-.79.31-1.59.47-2.38a160.302 160.302 0 0110.54-33.7c.16-.36.32-.72.5-1.08a108.305 108.305 0 018.61-15.35.01.01 0 01.01-.01 94.956 94.956 0 015.8-7.69 79.119 79.119 0 0118.72-16.24c.04-.03.09-.05.13-.08 14.04-8.71 30.68-12.86 46.59-9.27h.01c.41.09.81.18 1.22.28z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M282.012 685.403c-.34.09-.68.19-1.01.29a98.589 98.589 0 00-20.17 8.27c-.32.17-.64.35-.96.53a98.255 98.255 0 00-23.79 18.59.035.035 0 00-.01.02c-.08.08-.17.17-.24.25a90.03 90.03 0 00-4.6 5.35 42.769 42.769 0 00-6.82 11.43 23.674 23.674 0 00-1.31 10.81c.03.37.08.73.13 1.1.04.29.08.58.13.88.66 4.01 1.8 8.03 1.48 12.12a14.91 14.91 0 01-6.01 10.63 23.794 23.794 0 01-3.68 2.34 36.852 36.852 0 01-5.77 2.38h-3.93l1.58-.45a48.212 48.212 0 005.53-1.93 26.912 26.912 0 003-1.48c4.02-2.31 7.37-5.85 8.07-10.58.61-4.14-.57-8.28-1.27-12.33-.12-.7-.23-1.39-.29-2.08a24.439 24.439 0 01.85-10.46 39.062 39.062 0 016.36-11.66 83.355 83.355 0 015.48-6.55q.36-.405.75-.81a100.901 100.901 0 0124.21-18.73h.01a99.288 99.288 0 0121.1-8.74h.01c.33-.1.67-.2 1-.29.69-.18.85.91.17 1.1z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M235.116 713.252a14.807 14.807 0 01-1.036-19.145c.432-.564 1.329.08.896.646a13.711 13.711 0 001 17.807c.492.514-.372 1.203-.86.692z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M222.755 740.937a28.54 28.54 0 0019.63-6.876c.539-.464 1.23.397.692.86a29.685 29.685 0 01-20.44 7.114c-.712-.028-.59-1.126.118-1.098z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M260.644 693.674a8.381 8.381 0 006.888 3.977c.711.019.588 1.117-.12 1.098a9.392 9.392 0 01-7.628-4.382.57.57 0 01.084-.777.555.555 0 01.776.084z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#ffb8b8'
        d='M625.03 300.737a11.6 11.6 0 01-17.766.837l-37.8 16.44 3.682-21.101 35.331-12.377a11.662 11.662 0 0116.554 16.2z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#03045e'
        fillOpacity='1'
        d='M599.806 307.325l-87.798 39.109-.188-.068-100.067-35.659a32.96 32.96 0 01-14.782-42.755 32.924 32.924 0 0146.987-14.637l74.469 44.86 72.211-9.36z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#ccc'
        d='M1031.352 771.203a1.187 1.187 0 01-1.19 1.19h-860.29a1.19 1.19 0 010-2.38h860.29a1.187 1.187 0 011.19 1.19z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#03045e'
        fillOpacity='1'
        d='M481.992 424.404l-88.506-14.157a16.893 16.893 0 01-9.955-23.646l4.013-8.029-1.559-84.346a62.482 62.482 0 0130.337-54.654l8.63-5.16 4.362-11.077 40.22.98.118 14.528 14.403 22.968v.096l-.904 125.013-3.97 12.902 6.003 15.005z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <circle cx='284.459' cy='45.41' r='36.544' fill='#ffb8b8'></circle>
      <path
        fill='#2f2e41'
        d='M415.054 180.984c-1.09-4.592-.59-11.054.026-15.677 1.615-12.122 8.347-23.645 18.574-30.471a13.38 13.38 0 016.664-2.648c2.42-.101 5.042 1.194 5.785 3.499a11.993 11.993 0 016.765-6.71 21.136 21.136 0 019.631-1.297 35.197 35.197 0 0129.363 20.99c.976 2.318 3.703-6.247 4.94-4.056a9.74 9.74 0 005.523 4.854c2.423.676 3.408 10.66 4.361 8.332a11.098 11.098 0 01-10.61 15.475c-2.467-.092-4.825-1-7.262-1.39-8.715-1.396-17.96 4.923-19.823 13.55a23.987 23.987 0 00-3.156-7.02 8.119 8.119 0 00-6.513-3.579c-2.48.093-4.66 1.714-6.268 3.603s-2.817 4.093-4.438 5.972c-4.755 5.513-11.187 18.37-17.964 17.432-5.349-.74-14.11-14.59-15.598-20.86z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M674.012 342.148a7.133 7.133 0 00-4.807-7.854l-98.413-32.777a7.132 7.132 0 00-2.933-.337l-24.667 2.333-14.153 1.342-26.12 2.469a7.155 7.155 0 00-6.383 5.99l-13.261 82.837a7.186 7.186 0 004.484 7.796l99.44 38.384a6.947 6.947 0 001.447.389 7.136 7.136 0 002.176.016l64.255-9.523a7.12 7.12 0 006.023-6z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#023e8a'
        d='M490.013 398.11l99.44 38.383a.897.897 0 00.458.053l64.247-9.522a.883.883 0 00.754-.752l12.92-85.066a.905.905 0 00-.6-.982l-.66-.224-97.758-32.546a.678.678 0 00-.138-.033.887.887 0 00-.23-.012l-60.164 5.693-4.774.448a.903.903 0 00-.795.748l-13.26 82.835a.897.897 0 00.56.977z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#2f2e41'
        d='M508.282 313.102l60.164-5.693a.887.887 0 01.23.012.678.678 0 01.138.033L666.57 340l-25.786 2.73-9.65 1.016-27.461 2.902a1.939 1.939 0 01-.241-.003c-.049-.015-.098-.03-.156-.045z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#3f3d56'
        d='M487.758 403.952l99.44 38.382a6.722 6.722 0 001.45.38 7.224 7.224 0 002.177.027l64.247-9.522a7.135 7.135 0 006.029-6.004l12.91-85.068a7.19 7.19 0 00-.419-3.716 6.244 6.244 0 00-.207-.462 6.99 6.99 0 00-2.263-2.698 7.138 7.138 0 00-1.916-.976l-.117-.041-98.292-32.738a8.955 8.955 0 00-1.227-.298 7.086 7.086 0 00-1.714-.033l-24.663 2.324-14.153 1.35-26.123 2.467a7.092 7.092 0 00-3.019.997 1.33 1.33 0 00-.202.122 1.192 1.192 0 00-.13.098 7.148 7.148 0 00-3.027 4.763l-13.27 82.844a7.194 7.194 0 004.489 7.802zm10.542-90.357a5.3 5.3 0 011.27-2.671 4.651 4.651 0 01.675-.659 5.317 5.317 0 012.324-1.084 4.059 4.059 0 01.51-.072l43.984-4.155 20.965-1.995c.142-.016.272-.014.403-.022a5.007 5.007 0 01.948.07 4.145 4.145 0 01.845.202l98.408 32.779c.078.027.146.054.223.082a5.218 5.218 0 012.273 1.653 5.26 5.26 0 011.121 4.146l-12.92 85.076a5.35 5.35 0 01-4.51 4.502l-64.256 9.521a5.413 5.413 0 01-2.723-.31l-99.44-38.372a5.402 5.402 0 01-3.36-5.846z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#3f3d56'
        d='M499.352 308.994a.877.877 0 01.268-.386 1.051 1.051 0 01.13-.088c.04-.016.084-.042.125-.058a.873.873 0 01.624-.011l2.07.73 101.116 35.67 23.665-2.5 13.243-1.398 28.03-2.967 2.505-.263.488-.054a.904.904 0 01.952.654.74.74 0 01.026.143.893.893 0 01-.55.922.988.988 0 01-.247.067l-3.41.357-27.602 2.918-9.65 1.016-27.461 2.902a1.939 1.939 0 01-.241-.003c-.049-.015-.098-.03-.156-.045l-103.032-36.335-.35-.124a.67.67 0 01-.219-.121.91.91 0 01-.324-1.026z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#3f3d56'
        d='M588.92 442.975a.894.894 0 01-.743-1.016l14.516-96.334a.894.894 0 011.017-.75h.008a.894.894 0 01.743 1.016l-14.517 96.334a.894.894 0 01-1.017.75z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#3f3d56'
        d='M625.716 436.863l-9.655 1.02 11.294-95.535s12.894-2.335 13.24-1.399c.211.56-14.787 95.302-14.879 95.914z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#3f3d56'
        d='M331.25 182.533L330.99 226.1 408.116 255.488 435.813 218.284 331.25 182.533z'
      ></path>
      <path
        fill='#3f3d56'
        d='M671.131 337.725a5.301 5.301 0 00-2.496-1.737l-98.406-32.778a5.106 5.106 0 00-.848-.206 5.009 5.009 0 00-.951-.071l.16-.998.985-.713 23.368-16.919 78.04 23.917.136 27.052z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#fff'
        d='M503.829 380.08a1.513 1.513 0 01.326.068l30.194 9.917a1.5 1.5 0 01-.936 2.85L503.22 383a1.5 1.5 0 01.61-2.92z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <circle cx='457.003' cy='423.236' r='12' fill='#f2f2f2'></circle>
      <circle cx='151.003' cy='467.236' r='12' fill='#f2f2f2'></circle>
      <circle cx='401.003' cy='70.236' r='12' fill='#f2f2f2'></circle>
      <path
        fill='#ffb8b8'
        d='M589.34 397.729a11.6 11.6 0 01-15.907-7.958l-41.012-4.143 13.53-16.606 36.872 6.48a11.662 11.662 0 016.517 22.227z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#03045e'
        fillOpacity='1'
        d='M564.115 391.14l-95.708-8.818-.132-.15-69.85-80.037a32.96 32.96 0 018.013-44.523 32.924 32.924 0 0148.143 10.209l43.023 75.544 67.565 27.147z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#2f2e41'
        d='M804.339 237.224c-2.377-17.434-5.358-36.152-17.655-48.737a41.35 41.35 0 00-59.743.618c-8.951 9.549-12.904 22.957-13.266 36.04s2.552 26.02 5.785 38.704a119.29 119.29 0 0049.785-9.8c3.927-1.704 7.79-3.63 11.937-4.686 4.148-1.056 7.105 1.6 10.963 3.453l2.118-4.055c1.734 3.226 7.103 2.27 9.05-.833 1.947-3.102 1.52-7.075 1.026-10.704z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#9e616a'
        d='M736.532 334.532l-69.876 1.495a11.055 11.055 0 10-4.94 15.574c9.268.526 81.772 10.817 86.098 4.185 4.39-6.73 27.824-30.486 27.824-30.486l-18.013-25.644z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <circle cx='584.911' cy='94.035' r='32.83' fill='#9e616a'></circle>
      <path
        fill='#48cae4'
        fillOpacity='1'
        d='M806.142 284.81c-3.869-7.7-5.749-17.211-13.997-19.707-5.57-1.686-28.097.84-33.173 3.685-8.443 4.734-.792 13.603-5.773 21.903-5.415 9.022-20.132 27.13-25.547 36.152-3.723 6.203 8.817 24.41 6.804 31.358s-2.11 14.747 1.32 21.117c3.068 5.702-1.372 10.745 1.714 16.437 3.21 5.92 7.149 28.053 4.162 34.088l-2 6c19.846 1.166 36.534-22.544 56.258-25.042 4.899-.62 9.985-1.43 14.022-4.274 5.947-4.189 8.297-11.79 9.767-18.913a159.326 159.326 0 00-13.557-102.803z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#9e616a'
        d='M835.898 366.112c-2.765-7.545-7.77-40.536-7.77-40.536l-31.323-.919 15.314 37.772-41.79 58.503.218.358a11.052 11.052 0 109.27 11.745.763.763 0 00.958-.165c4.65-5.835 57.887-59.212 55.123-66.758z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#48cae4'
        fillOpacity='1'
        d='M839.083 345.277c-2.876-12.134-5.772-24.335-10.62-35.825s-11.786-22.343-21.546-30.106c-3.12-2.481-6.609-4.672-10.52-5.444-3.912-.771-8.32.092-11.067 2.982-4.397 4.623-3.074 12.045-1.462 18.218l14.263 54.6 41.188-4.365z'
        transform='translate(-168.648 -127.607)'
      ></path>
      <path
        fill='#2f2e41'
        d='M793.787 226.196c-1.209-7.942-2.472-15.95-5.312-23.429-2.84-7.478-7.419-14.482-13.987-18.718-10.398-6.708-23.862-5.414-35.52-1.556-9.017 2.984-17.818 7.519-24.176 14.81-6.359 7.29-9.93 17.693-7.565 27.226l37.31-8.815-1.362.962a30.038 30.038 0 0116.03 20.893 31.122 31.122 0 01-6.565 25.848l25.445-9.027c5.235-1.857 10.839-3.997 13.943-8.76 3.6-5.523 2.763-12.843 1.76-19.434z'
        transform='translate(-168.648 -127.607)'
      ></path>
    </svg>
  );
}

export default React.memo(Empty);